import { Stack, Typography } from '@optimus-web/core';
import { TransactionHistoryItem } from '@mews-commander/data-access';
import { LocalizedCurrencyValue, LocalizedText, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { LocalizedDateTimeFromUtc } from '@mews-commander/ui';
import { ActivityLog, LogItemProps } from '@mews/b2b-ui';
import { transactionHistoryItemTypeDescriptionLabelMap, transactionHistoryItemTypeTitleLabelMap } from './utils';

export interface PaymentDetailsSidePanelTransactionHistoryProps {
    historyItems: TransactionHistoryItem[];
}

export const PaymentDetailsSidePanelTransactionHistory = ({
    historyItems,
}: PaymentDetailsSidePanelTransactionHistoryProps) => {
    const localizeText = useLocalizeText();

    if (historyItems.length === 0) {
        return null;
    }

    const indicatorItems: LogItemProps[] = historyItems.map((historyItem) => ({
        ariaLabel: localizeText({ textKey: transactionHistoryItemTypeTitleLabelMap[historyItem.type] }),
        key: `${historyItem.type}${historyItem.createdUtc}`,
        stepName: localizeText({ textKey: transactionHistoryItemTypeTitleLabelMap[historyItem.type] }),
        amount: (
            <LocalizedCurrencyValue
                value={{
                    value: historyItem.amount.value,
                    currency: historyItem.amount.currencyCode,
                }}
            />
        ),
        description: localizeText({ textKey: transactionHistoryItemTypeDescriptionLabelMap[historyItem.type] }),
        date: <LocalizedDateTimeFromUtc utcString={historyItem.createdUtc} />,
    }));

    return (
        <Stack spacing="300" vertical>
            <Typography textStyle="titleSmallStrong" as="div">
                <LocalizedText textKey={TextKey.PayoutDetailTransactionHistory} />
            </Typography>
            <ActivityLog items={indicatorItems} />
        </Stack>
    );
};
